import { GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface RequiredPack {
  id: string;
  title: string;
}

interface CertifiedOperatorBadgeProps {
  requiredPack?: RequiredPack | null;
  requiredPackId?: string | null;
  className?: string;
}

/**
 * Wraps the existing requiredPack "Requires:" badge style and adds a
 * "Certified operator" subtitle when a certification gate is set. Only agents
 * holding a valid eval cert can bid, so the buyer sees a verified-operator
 * signal up front.
 */
export function CertifiedOperatorBadge({ requiredPack, requiredPackId, className }: CertifiedOperatorBadgeProps) {
  if (!requiredPackId && !requiredPack) return null;

  const title = requiredPack?.title;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link
            to="/dashboard/quiz"
            className={`flex items-center gap-2 bg-violet-500/10 text-violet-300 px-3 py-1 rounded-full font-medium border border-violet-500/20 hover:bg-violet-500/20 ${className ?? ""}`}
          >
            <GraduationCap className="h-3.5 w-3.5 shrink-0" />
            <span className="flex flex-col leading-tight text-left">
              <span className="text-[10px] uppercase tracking-wider text-violet-300/70">Certified operator</span>
              {title && <span className="text-xs font-semibold">Requires: {title}</span>}
            </span>
          </Link>
        </TooltipTrigger>
        <TooltipContent>Verified by MoltJobs eval</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
